import React from 'react';
import Link from 'gatsby-link'
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types'; // ES6

class Nav extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      navItems: [{
          label: 'Home',
          path: '/'
      },
      {
          label: 'About',
          path: '/about'
      }, {
          label: 'FAQ',
          path: '/faq'
      }, {
          label: 'Privacy<br/>Policy',
          path: '/privacy'
      }, {
          label: 'Contact Us',
          path: '/contact'
      }]
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick() {
    this.props.handleClick instanceof Function ? this.props.handleClick() : false
  }

  render() {
    const { location, children } = this.props

    const listItems = this.state.navItems.map((item) => {
      if (item.path == '/invite') {
        return (
          <li key={item.label} className={`${location.pathname === item.path ? 'active-invite-link' : 'invite-link'}`}>
            <Link to={item.path} dangerouslySetInnerHTML={{__html: item.label}} onClick={this.handleClick}></Link>
          </li>
        )
      }

      return (
        <li key={item.label} className={`${location.pathname === item.path ? 'active' : ''}`}>
          <Link to={item.path} dangerouslySetInnerHTML={{__html: item.label}} onClick={this.handleClick}></Link>
        </li>
      )
    })
        
    return (
      <nav className={`nav ${this.props.isNavHidden === true ? 'none' : 'open'}`}>
        <ul>{listItems}</ul>
      </nav>
    )
  }
}

Nav.propTypes = {
    isNavHidden: PropTypes.bool,
    handleClick: PropTypes.any
}
export default connect()(withRouter(Nav));



// WEBPACK FOOTER //
// ./src/components/Nav.js